import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api_getDecor, api_editDecor, api_getCake, api_editCake, api_getPhoto, api_editPhoto, api_getVideo, api_editVideo } from '../../../api/catering/cateringPrice'; // Adjusted import for FoodCatering APIs
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../../components/bootstrap/Card';
import Button from '../../../components/bootstrap/Button';
import { toast } from 'react-hot-toast';

const AllCateringPrice = () => {
	const [decor, setDecor] = useState<any>([]); // State variable to hold decor items
	const [cake, setCake] = useState<any>([]); // State variable to hold cake items
	const [photo, setPhoto] = useState<any>([]); // State variable to hold photo items
	const [video, setVideo] = useState<any>([]); // State variable to hold video items
	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const navigate = useNavigate();

	// State variables for price editing
	const [fromDecorPrice, setFromDecorPrice] = useState<number | string>('');
	const [toDecorPrice, setToDecorPrice] = useState<number | string>('');

	const [fromCakePrice, setFromCakePrice] = useState<number | string>('');
	const [toCakePrice, setToCakePrice] = useState<number | string>('');

	const [fromPhotoPrice, setFromPhotoPrice] = useState<number | string>('');
	const [toPhotoPrice, setToPhotoPrice] = useState<number | string>('');

	const [fromVideoPrice, setFromVideoPrice] = useState<number | string>('');
	const [toVideoPrice, setToVideoPrice] = useState<number | string>('');

	// Function to fetch decor items
	const getDecor = async () => {
		try {
			setLoading(true);
			const res = await api_getDecor(); // Fetch decor items from API
	
			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
				} else {
					setDecor(res.data);
					setFromDecorPrice(res.data[0].price.from);
					setToDecorPrice(res.data[0].price.to);
				}
			} else {
				console.error('Failed to fetch decor items:', res.message);
			}
		} catch (error) {
			console.error('Error fetching decor items:', error);
		} finally {
			setLoading(false);
		}
	};

	// Function to handle price update
	const updateDecorPrice = async () => {
		try {
			const res = await api_editDecor(decor[0]._id, { price: { from: Number(fromDecorPrice), to: Number(toDecorPrice) } });
			const message = typeof res.message === 'string' ? res.message : 'Success';
			if (res.isSuccess) {
				toast.success(message || 'Event type updated successfully');
				setTimeout(() => {
					navigate(-1);
				}, 100);
			} else {
				toast.error(message || 'Failed to update event type');
			}
		} catch (error) {
			console.error('Error updating price:', error);
			alert('Error updating price');
		}
	};

	// Function to fetch cake items
	const getCake = async () => {
		try {
			setLoading(true);
			const res = await api_getCake(); // Fetch cake items from API
			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
				} else {
					setCake(res.data);
					setFromCakePrice(res.data[0].price.from);
					setToCakePrice(res.data[0].price.to);
				}
			} else {
				console.error('Failed to fetch cake items:', res.message);
			}
		} catch (error) {
			console.error('Error fetching cake items:', error);
		} finally {
			setLoading(false);
		}
	};

	// Function to handle cake price update
	const updateCakePrice = async () => {
		try {
			const res = await api_editCake(cake[0]._id, { price: { from: Number(fromCakePrice), to: Number(toCakePrice) } });
			const message = typeof res.message === 'string' ? res.message : 'Success';
			if (res.isSuccess) {
				toast.success(message || 'Event type updated successfully');
				setTimeout(() => {
					navigate(-1);
				}, 100);
			} else {
				toast.error(message || 'Failed to update event type');
			}
		} catch (error) {
			console.error('Error updating price:', error);
			alert('Error updating price');
		}
	};

	// Function to fetch photo items
	const getPhoto = async () => {
		try {
			setLoading(true);
			const res = await api_getPhoto(); // Fetch photo items from API
			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
				} else {
					setPhoto(res.data);
					setFromPhotoPrice(res.data[0].price.from);
					setToPhotoPrice(res.data[0].price.to);
				}
			} else {
				console.error('Failed to fetch photo items:', res.message);
			}
		} catch (error) {
			console.error('Error fetching photo items:', error);
		} finally {
			setLoading(false);
		}
	};

	// Function to handle photo price update
	const updatePhotoPrice = async () => {
		try {
			const res = await api_editPhoto(photo[0]._id, { price: { from: Number(fromPhotoPrice), to: Number(toPhotoPrice) } });
			const message = typeof res.message === 'string' ? res.message : 'Success';
			if (res.isSuccess) {
				toast.success(message || 'Event type updated successfully');
				setTimeout(() => {
					navigate(-1);
				}, 100);
			} else {
				toast.error(message || 'Failed to update event type');
			}
		} catch (error) {
			console.error('Error updating price:', error);
			alert('Error updating price');
		}
	};

	// Function to fetch video items
	const getVideo = async () => {
		try {
			setLoading(true);
			const res = await api_getVideo(); // Fetch video items from API
			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
				} else {
					setVideo(res.data);
					setFromVideoPrice(res.data[0].price.from);
					setToVideoPrice(res.data[0].price.to);
				}
			} else {
				console.error('Failed to fetch video items:', res.message);
			}
		} catch (error) {
			console.error('Error fetching video items:', error);
		} finally {
			setLoading(false);
		}
	};

	// Function to handle video price update
	const updateVideoPrice = async () => {
		try {
			const res = await api_editVideo(video[0]._id, { price: { from: Number(fromVideoPrice), to: Number(toVideoPrice) } });
			const message = typeof res.message === 'string' ? res.message : 'Success';
			if (res.isSuccess) {
				toast.success(message || 'Event type updated successfully');
				setTimeout(() => {
					navigate(-1);
				}, 100);
			} else {
				toast.error(message || 'Failed to update event type');
			}
		} catch (error) {
			console.error('Error updating price:', error);
			alert('Error updating price');
		}
	};

	// Fetch items on component mount
	useEffect(() => {
		getDecor();
		getCake();
		getPhoto();
		getVideo();
	}, []);

	return (
		<PageWrapper title={'Catering Price'}>
			<Card stretch>
				<CardHeader borderSize={1}>
					<CardLabel icon='Money' iconColor='info'>
						<CardTitle>All Catering Price</CardTitle>
					</CardLabel>
				</CardHeader>
				<CardBody>
					<div className='row'>
						{/* First Quadrant: Edit Decor Price */}
						<div className='col-12 col-md-6 col-lg-3'>
							<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
								<h3>Decor</h3>
								<div className='mb-3'>
									<label htmlFor='fromDecorPrice' className='form-label'>From Price</label>
									<input
										id='fromDecorPrice'
										type='number'
										value={fromDecorPrice}
										onChange={(e) => setFromDecorPrice(e.target.value)}
										style={{ width: '100%' }}
										className='form-control'
										placeholder='Enter from price'
									/>
								</div>
								<div className='mb-3'>
									<label htmlFor='toDecorPrice' className='form-label'>To Price</label>
									<input
										id='toDecorPrice'
										type='number'
										value={toDecorPrice}
										onChange={(e) => setToDecorPrice(e.target.value)}
										style={{ width: '100%' }}
										className='form-control'
										placeholder='Enter to price'
									/>
								</div>
								<Button onClick={updateDecorPrice} color='primary'>
									{loading ? 'Loading..' : 'Update Price'}
								</Button>
							</div>
						</div>

						{/* Second Quadrant: Edit Cake Price */}
						<div className='col-12 col-md-6 col-lg-3'>
							<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
								<h3>Cake</h3>
								<div className='mb-3'>
									<label htmlFor='fromCakePrice' className='form-label'>From Price</label>
									<input
										id='fromCakePrice'
										type='number'
										value={fromCakePrice}
										onChange={(e) => setFromCakePrice(e.target.value)}
										style={{ width: '100%' }}
										className='form-control'
										placeholder='Enter from price'
									/>
								</div>
								<div className='mb-3'>
									<label htmlFor='toCakePrice' className='form-label'>To Price</label>
									<input
										id='toCakePrice'
										type='number'
										value={toCakePrice}
										onChange={(e) => setToCakePrice(e.target.value)}
										style={{ width: '100%' }}
										className='form-control'
										placeholder='Enter to price'
									/>
								</div>
								<Button onClick={updateCakePrice} color='primary'>
									{loading ? 'Loading..' : 'Update Price'}
								</Button>
							</div>
						</div>

						{/* Third Quadrant: Edit Photo Price */}
						<div className='col-12 col-md-6 col-lg-3'>
							<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
								<h3>Photo</h3>
								<div className='mb-3'>
									<label htmlFor='fromPhotoPrice' className='form-label'>From Price</label>
									<input
										id='fromPhotoPrice'
										type='number'
										value={fromPhotoPrice}
										onChange={(e) => setFromPhotoPrice(e.target.value)}
										style={{ width: '100%' }}
										className='form-control'
										placeholder='Enter from price'
									/>
								</div>
								<div className='mb-3'>
									<label htmlFor='toPhotoPrice' className='form-label'>To Price</label>
									<input
										id='toPhotoPrice'
										type='number'
										value={toPhotoPrice}
										onChange={(e) => setToPhotoPrice(e.target.value)}
										style={{ width: '100%' }}
										className='form-control'
										placeholder='Enter to price'
									/>
								</div>
								<Button onClick={updatePhotoPrice} color='primary'>
									{loading ? 'Loading..' : 'Update Price'}
								</Button>
							</div>
						</div>

						{/* Fourth Quadrant: Edit Video Price */}
						<div className='col-12 col-md-6 col-lg-3'>
							<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
								<h3>Video</h3>
								<div className='mb-3'>
									<label htmlFor='fromVideoPrice' className='form-label'>From Price</label>
									<input
										id='fromVideoPrice'
										type='number'
										value={fromVideoPrice}
										onChange={(e) => setFromVideoPrice(e.target.value)}
										style={{ width: '100%' }}
										className='form-control'
										placeholder='Enter from price'
									/>
								</div>
								<div className='mb-3'>
									<label htmlFor='toVideoPrice' className='form-label'>To Price</label>
									<input
										id='toVideoPrice'
										type='number'
										value={toVideoPrice}
										onChange={(e) => setToVideoPrice(e.target.value)}
										style={{ width: '100%' }}
										className='form-control'
										placeholder='Enter to price'
									/>
								</div>
								<Button onClick={updateVideoPrice} color='primary'>
									{loading ? 'Loading..' : 'Update Price'}
								</Button>
							</div>
						</div>
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							marginBottom: '20px',
						}}>
						{hasMore && (
							<button
								style={{
									border: 'none',
									padding: '10px',
									borderRadius: '10px',
									cursor: 'pointer',
								}}
								onClick={getDecor}>
								Load More...
							</button>
						)}
					</div>
				</CardBody>
			</Card>
		</PageWrapper>
	);
};

export default AllCateringPrice;
